export default "__VITE_ASSET__52690ab9__"